import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { FinancialMonitorRequestDto } from "../../../api/apiServices/backOffice/controllers/managementReports/managementReports.requestsDto";
import ManagementDebtReportDto from "../../../dto/ManagementReports/ManagementDebtReportDto";
import ManagementSettlementAccountReportDto from "../../../dto/ManagementReports/ManagementSettlementAccountReportDto";
import { createEmptyDetails, FinancialDetailsRequest, FinancialDetailsState } from "./details";

const initialState: {
  details: FinancialDetailsState;
  loading: boolean;
  error: boolean;
  partial: boolean;
  debtReport?: ManagementDebtReportDto;
  settlementAccountReport?: ManagementSettlementAccountReportDto;
} = {
  details: createEmptyDetails(),
  loading: true,
  error: false,
  partial: false,
};

const financialMonitorSlice = createSlice({
  name: "adminPanelFinancialMonitor",
  initialState,
  reducers: {
    loadFinancialDetails(state, action: PayloadAction<FinancialDetailsRequest>) {
      state.details = { ...createEmptyDetails(), request: action.payload, loading: true };
    },
    loadFinancialDetailsSuccess(
      state,
      action: PayloadAction<
        Pick<FinancialDetailsState, "deals" | "changedDeals" | "accounts" | "sameDayPaidDeals"> & { requestId: string }
      >,
    ) {
      if (state.details.request?.requestId !== action.payload.requestId) return;
      state.details.loading = false;
      state.details.error = false;
      state.details.deals = action.payload.deals;
      state.details.changedDeals = action.payload.changedDeals;
      state.details.sameDayPaidDeals = action.payload.sameDayPaidDeals;
      state.details.accounts = action.payload.accounts;
    },
    loadFinancialDetailsReject(state, action: PayloadAction<string>) {
      if (state.details.request?.requestId !== action.payload) return;
      state.details.loading = false;
      state.details.error = true;
    },
    closeFinancialDetails(state) {
      state.details = createEmptyDetails();
    },
    loadFinancialMonitor(state, _action: PayloadAction<FinancialMonitorRequestDto>) {
      state.details = createEmptyDetails();
      state.loading = true;
      state.error = false;
      state.partial = false;
    },
    loadFinancialMonitorSuccess(
      state,
      action: PayloadAction<{
        debtReport: ManagementDebtReportDto;
        settlementAccountReport: ManagementSettlementAccountReportDto;
        partial: boolean;
      }>,
    ) {
      state.loading = false;
      state.error = false;
      state.partial = action.payload.partial;
      state.debtReport = action.payload.debtReport;
      state.settlementAccountReport = action.payload.settlementAccountReport;
    },
    loadFinancialMonitorReject(state) {
      state.loading = false;
      state.error = true;
      state.partial = false;
    },
    clearFinancialMonitor(state) {
      state.details = createEmptyDetails();
      state.loading = true;
      state.error = false;
      state.partial = false;
      state.debtReport = undefined;
      state.settlementAccountReport = undefined;
    },
  },
});

export default financialMonitorSlice;
